"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var Breadcrumb = /** @class */ (function (_super) {
    __extends(Breadcrumb, _super);
    function Breadcrumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Breadcrumb.prototype.render = function (props) {
        var items = [];
        props.items.forEach(function (item, index) {
            if (index !== props.items.length - 1) {
                items.push(omi_1.h("li", { class: "breadcrumb-li" },
                    item.icon && omi_1.h("i", { class: "material-icons mdc-icon-button__icon" }, item.icon),
                    omi_1.h("a", { class: "", href: item.href }, item.text)), omi_1.h("li", { class: 'split' }, props.split));
            }
            else {
                items.push(omi_1.h("li", { class: "current" },
                    item.icon && omi_1.h("i", { class: "material-icons mdc-icon-button__icon" }, item.icon),
                    item.text));
            }
        });
        return (omi_1.h("nav", __assign({}, omi_1.extractClass(props, 'm-breadcrumb')),
            omi_1.h("ol", { class: "breadcrumb-ol" }, items)));
    };
    Breadcrumb.css = css;
    Breadcrumb.defaultProps = {
        split: '/'
    };
    Breadcrumb.propTypes = {
        items: Object,
        split: String
    };
    Breadcrumb = __decorate([
        omi_1.tag('m-breadcrumb')
    ], Breadcrumb);
    return Breadcrumb;
}(omi_1.WeElement));
exports.default = Breadcrumb;
